import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import FuturaIcon from "./FuturaIcon";

const LegalFooter = ({ variant = "dark" }) => {
  const { t } = useLanguage();
  const isDark = variant === "dark";

  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent("open-cookie-settings"));
  };

  return (
    <footer
      className={`py-8 px-6 ${isDark ? "bg-[#111111]" : "bg-[#F5F5F7] border-t border-[#E5E5EA]"}`}
      data-testid="legal-footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#002FA7] to-[#5B21B6] flex items-center justify-center p-1">
              <FuturaIcon className="w-full h-full text-white" />
            </div>
            <span className="font-['Outfit'] font-semibold text-sm text-white">FUTURA</span>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs" aria-label="Legal">
            <Link
              to="/privacidad"
              className={`${isDark ? "text-[#6B7280] hover:text-white" : "text-[#6B7280] hover:text-[#111]"} transition-colors`}
              data-testid="legal-footer-privacy"
            >
              {t("legal_privacy")}
            </Link>
            <Link
              to="/cookies"
              className={`${isDark ? "text-[#6B7280] hover:text-white" : "text-[#6B7280] hover:text-[#111]"} transition-colors`}
              data-testid="legal-footer-cookies"
            >
              {t("legal_cookies")}
            </Link>
            <Link
              to="/terminos"
              className={`${isDark ? "text-[#6B7280] hover:text-white" : "text-[#6B7280] hover:text-[#111]"} transition-colors`}
              data-testid="legal-footer-terms"
            >
              {t("legal_terms")}
            </Link>
            <Link
              to="/eliminar-cuenta"
              className={`${isDark ? "text-[#6B7280] hover:text-white" : "text-[#6B7280] hover:text-[#111]"} transition-colors`}
              data-testid="legal-footer-delete"
            >
              {t("legal_delete_account")}
            </Link>
            <button
              onClick={openCookieSettings}
              className={`${isDark ? "text-[#6B7280] hover:text-white" : "text-[#6B7280] hover:text-[#111]"} transition-colors`}
              data-testid="legal-footer-cookie-settings"
            >
              {t("legal_cookie_settings")}
            </button>
          </nav>
        </div>
        <p className={`text-center text-[10px] mt-4 ${isDark ? "text-[#6B7280]/50" : "text-[#6B7280]/60"}`}>
          &copy; {new Date().getFullYear()} FUTURA. {t("legal_rights")}
        </p>
      </div>
    </footer>
  );
};

export default LegalFooter;
